// extracted by mini-css-extract-plugin
export default {"tabPanel":"_6c97a9ff"};